import { useState, useEffect } from 'react';
import { IframeDetectionResult } from '@/types/auth.types';

export const useIframeDetection = (): IframeDetectionResult => {
  const [result, setResult] = useState<IframeDetectionResult>({
    isInIframe: false,
    authMethod: null
  });

  useEffect(() => {
    const detectContext = () => {
      try {
        // Primary iframe detection
        const inIframe = window.self !== window.top;
        
        // Additional checks for more robust detection
        const hasParent = window.parent !== window;
        const frameElement = window.frameElement !== null;
        
        // Check if we can access parent window (may throw in cross-origin scenarios)
        let canAccessParent = false;
        try {
          canAccessParent = !!window.parent.location.href;
        } catch (e) {
          // Cross-origin iframe - can't access parent
          canAccessParent = false;
        }

        const isIframe = inIframe || hasParent || frameElement || !canAccessParent;
        
        console.log('Context detection:', {
          inIframe,
          hasParent,
          frameElement: !!frameElement,
          canAccessParent,
          finalResult: isIframe
        });

        const authMethod = isIframe ? 'device' : 'direct';

        setResult({
          isInIframe: isIframe,
          authMethod
        });
      } catch (error) {
        console.error('Error detecting iframe context:', error);
        // Default to iframe mode if detection fails (safer for cross-origin scenarios)
        setResult({
          isInIframe: true,
          authMethod: 'device'
        });
      }
    };

    // Detect immediately
    detectContext();

    // Also detect after a short delay to handle dynamic contexts
    const timeoutId = setTimeout(detectContext, 100);

    return () => clearTimeout(timeoutId);
  }, []);

  return result;
};